import { render, staticRenderFns } from "./PersonalSettings.vue?vue&type=template&id=70ee3f3c&scoped=true"
import script from "./PersonalSettings.vue?vue&type=script&lang=js"
export * from "./PersonalSettings.vue?vue&type=script&lang=js"
import style0 from "./PersonalSettings.vue?vue&type=style&index=0&id=70ee3f3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ee3f3c",
  null
  
)

export default component.exports